export default (function (_a) {
    var baseUnit = _a.theme.constants.SIZE_SUB_UNIT, height = _a.height;
    if (typeof height === "object") {
        var _b = height.min, min = _b === void 0 ? "" : _b, _c = height.max, max = _c === void 0 ? "" : _c;
        return "\n      " + (min && "min-height: " + (typeof min === "number" ? baseUnit * min + "px" : min) + ";") + "\n      " + (max && "max-height: " + (typeof max === "number" ? baseUnit * max + "px" : max) + ";") + "\n    ";
    }
    return height && "height: " + (typeof height === "number" ? baseUnit * height + "px" : height) + ";";
});
